import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { mergeAriaIds } from '../../../lib/aria';
import { cn } from '../../../lib/utils';
import { SpecraSwitch } from '../ensigns/switch';
/** Switch plus its visible label and optional supporting description. */ export function SpecraSwitchField({ className, controlProps, description, label, ...props }) {
    const generatedId = React.useId();
    const id = controlProps?.id ?? generatedId;
    const labelId = `${id}-label`;
    const descriptionId = description ? `${id}-description` : undefined;
    const describedBy = mergeAriaIds(controlProps?.['aria-describedby'], descriptionId);
    const accessibleName = controlProps?.['aria-label'] ? {
        'aria-label': controlProps['aria-label']
    } : {
        'aria-labelledby': controlProps?.['aria-labelledby'] ?? labelId
    };
    return /*#__PURE__*/ _jsxs("label", {
        className: cn('inline-flex items-start gap-[var(--space-2-5)] text-[length:var(--fs-ui-title)] text-foreground has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50', className),
        htmlFor: id,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraSwitch, {
                ...controlProps,
                ...accessibleName,
                "aria-describedby": describedBy,
                id: id
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "block",
                        id: labelId,
                        children: label
                    }),
                    description ? /*#__PURE__*/ _jsx("span", {
                        className: "mt-[var(--space-0-5)] block text-[length:var(--fs-ui-caption)] text-muted-foreground",
                        id: descriptionId,
                        children: description
                    }) : null
                ]
            })
        ]
    });
}
